import t from '../utils/lang'

export function formatUser (user) {
  const { id, name, avatarURL, answers, questions } = user
  const answeredQuestions = Object.keys(answers).length ? Object.keys(answers).length : 0
  const createdQuestions = questions.length ? questions.length : 0
  const score = answeredQuestions + createdQuestions

  return {
    id,
    name,
    avatarURL,
    answeredQuestions,
    createdQuestions,
    score
  }
}

export const getMonthSuffix = (month, lang) => {
  if (month == 1)
    return t[lang].month;
  else if ([2,3,4].includes(month % 10)) {
    return [12,13,14].includes(month % 100)
      ? t[lang].months1
      : t[lang].months2;
  } else return t[lang].months1;
}


// WEBPACK FOOTER //
// ./src/utils/helpers.js